'use strict';

angular.module('app')
  .controller('WizardCtrl', function ($scope, $rootScope, $location, $timeout,config, MarineLife, utils) {

  	var vm = this,
  		query = $location.search(),
  		marineLifesCloned = [],
        loading;

    vm.step = query.step ? 1 : 0;

    $location.search('step',null);

    vm.utils = utils;

    vm.api = MarineLife;

    vm.showMore = showMore;

    vm.monthes = config.monthsWithCode;

    vm.selectedInfo = {
        page: 1
    };

    vm.units = 'metric';

    vm.measurement = {
    	temp : '°C',
    	lgth : 'mm'
    }

    if(query.month && query.critter_id || query.group_id){
    	vm.selectedInfo = query;
        vm.selectedInfo.page = 1;
    	vm.step = 5;
    	getResultData();
    }

    vm.flight = {
    	ceil: 30,
    	min: 0,
    	max: 30
    };

    vm.changeStep = function (step, model, send) {
    	if (send) {
    		getResultData();
    	}

    	if (vm.selectedInfo[model]) {
    		vm.step = step;
        }
    }

    vm.startOver = function() {
    	vm.step = 1;

    	$location.search({});

    	vm.selectedInfo = {page: 1};
    }

    vm.changeUnits = function (type) {
    	if (vm.units != type) {
    		vm.units = type;

    		if (vm.units === 'imperial') {
    			vm.measurement.temp = '°F';
    			vm.measurement.lgth = 'inch';

	    		_.each(vm.resultData, function(val) {
					val.airTemp = vm.utils.toFahrenheit(val.airTemp, true);
					val.rainfall = vm.utils.toInch(val.rainfall, true);
					val.waterTemp = vm.utils.toFahrenheit(val.waterTemp, true);
			    });
    		} else {
    			vm.resultData = _.cloneDeep(marineLifesCloned);
    			vm.measurement.temp = '°C';
    			vm.measurement.lgth = 'mm';
    		}
    	}
    }

    function showMore() {
        if (loading) {
            return 1;
        }

        loading = true;

        vm.selectedInfo.page += 1;


        MarineLife
        .sendParams(vm.selectedInfo)
        .then(function(data){
            vm.resultData = data.results.concat(vm.resultData);
            vm.next = data.next;
            loading = false;
        }).catch(function(){
            loading = false;
        })
    }   

    MarineLife.getMarineLife().then(function(data){
    	vm.marineLifes = data;
    });

    function getResultData () {
    	return MarineLife.sendParams(vm.selectedInfo).then(function(data){
			vm.resultData = _.cloneDeep(data.results);
            vm.next = data.next;

    		marineLifesCloned = _.clone(data.results);
            vm.currentMonth = data.month;
            vm.currentFish = data.title;
		}).catch(function() {
			vm.resultData = [];
			marineLifesCloned = [];
		});
    }


});
